module.exports = __webpack_public_path__ + "static/7-2bc76ced5aa3b26063e39d7a9f6c598b.wav";